export const BOARD_ID_NUM_DIGITS = 4;
export const COUNTDOWN_DURATION_SECS = 3;
export const TIMEOUT_DURATION_SECS = 120;
export const DEFAULT_BOARD_MODE = 'TESTING';
export const DEFAULT_BOARD_PORTRAIT_LAYOUT = '3x4';
export const DEFAULT_COLOR_SCHEME = 'dark';
export const DEFAULT_OVERRIDE_OS_DARK_MODE = true;
export const DEFAULT_PROMOTED = false;
export const DEFAULT_TILE_BACKGROUND_COLOR = '';
export const DEFAULT_TILE_BACKGROUND_POSITION = 'CENTER';
export const DEFAULT_TILE_BACKGROUND_SIZE = 'CONTAIN';
export const DEFAULT_TILE_IMAGE_FORMAT = 'PNG';
export const DEFAULT_TILE_RADIAL_GRADIENT_HEX_COLOR = '';
export const FIREBASE_STORAGE_USER_AVATARS_FOLDER = 'user-avatars';
export const GAMERTAG_MAX_LENGTH = 20;
export const GENERATE_FIREBASE_DOCUMENT_ID_LENGTH = 20;
export const GENERATE_PASSWORD_LENGTH = 16;
export const IMAGES_FOLDER_NAME_DELIMITER = '-';
export const INCORRECT_CLICK_FLASH_DURATION_MS = 50;
export const INCORRECT_CLICK_PENALTY_DURATION_SECS = 4;
export const LOGO_COLOR_LIST = ['yellow', 'orange', 'pink', 'violet', 'blue', 'green', 'teal', 'brown'];
export const MAXIMUM_CUSTOM_AVATAR_UPLOAD_BYTES = 4194304;
export const PAGE_TITLE_APP_NAME = 'Click ‘em Quick';
export const PAGE_TITLE_DELIMITER = ' | ';
export const PATH_TO_TILE_IMAGES = '/tiles/';
export const RANDOM_PROMPT_DELIMITER = '|';
export const USER_ROLE_ADMIN = 'admin';
export const USER_ROLE_EDITOR = 'editor';
export const USER_ROLE_PLAYER = 'player';
export const VUE_APP_MODE_DEVELOPMENT = 'development';
export const VUE_APP_MODE_PRODUCTION = 'production';
// eslint-disable-next-line prettier/prettier
export const GENERATE_PASSWORD_CHARS_POOL = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'j', 'k', 'm', 'n', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '2', '3', '4', '5', '6', '7', '8', '9', '!', '@', '#', '$', '%', '^', '&', '*', '='];
// eslint-disable-next-line prettier/prettier
export const GENERATE_FIREBASE_DOCUMENT_ID_CHARS_POOL = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
export const MOBILE_BREAKPOINTS = ['mq-xsm', 'mq-xsm-sm', 'mq-sm', 'mq-sm-md', 'mq-ipad', 'mq-md', 'mq-md-lg'];
export const DESKTOP_BREAKPOINTS = ['mq-lg', 'mq-lg-xlg', 'mq-xlg', 'mq-xxlg'];
export const LOGO_WITHOUT_NAME_BREAKPOINTS = ['mq-xsm', 'mq-xsm-sm'];
export const LOGO_WITH_NAME_BREAKPOINTS = ['mq-sm', 'mq-sm-md', 'mq-ipad', 'mq-md', 'mq-md-lg', 'mq-lg', 'mq-lg-xlg', 'mq-xlg', 'mq-xxlg'];

export const MANAGE_LOGIN_MODES = {
  RESET_PASSWORD: 'resetPassword',
  RECOVER_EMAIL: 'recoverEmail',
  VERIFY_EMAIL: 'verifyEmail',
};

export const TILE_IMAGE_FORMATS = {
  PNG: {
    CONSTANT: 'PNG',
    DISPLAY_NAME: '.png',
    EXTENSION: '.png',
  },
  JPG: {
    CONSTANT: 'JPG',
    DISPLAY_NAME: '.jpg',
    EXTENSION: '.jpg',
  },
  SVG: {
    CONSTANT: 'SVG',
    DISPLAY_NAME: '.svg',
    EXTENSION: '.svg',
  },
};

export const TILE_IMAGE_FORMATS_SELECT_DATA = [
  {
    value: TILE_IMAGE_FORMATS.PNG.CONSTANT,
    label: TILE_IMAGE_FORMATS.PNG.DISPLAY_NAME,
  },
  {
    value: TILE_IMAGE_FORMATS.JPG.CONSTANT,
    label: TILE_IMAGE_FORMATS.JPG.DISPLAY_NAME,
  },
  {
    value: TILE_IMAGE_FORMATS.SVG.CONSTANT,
    label: TILE_IMAGE_FORMATS.SVG.DISPLAY_NAME,
  },
];

export const PLAY_STATES = {
  COMPONENT_CREATED: {
    CONSTANT: 'COMPONENT_CREATED',
    CSS_MODIFIER: 'component-created',
  },
  READY: {
    CONSTANT: 'READY',
    CSS_MODIFIER: 'ready',
  },
  COUNTING_DOWN: {
    CONSTANT: 'COUNTING_DOWN',
    CSS_MODIFIER: 'counting-down',
  },
  PLAYING: {
    CONSTANT: 'PLAYING',
    CSS_MODIFIER: 'playing',
  },
  TIMEOUT: {
    CONSTANT: 'TIMEOUT',
    CSS_MODIFIER: 'timeout',
  },
  COMPLETED: {
    CONSTANT: 'COMPLETED',
    CSS_MODIFIER: 'completed',
  },
  SUMMARY: {
    CONSTANT: 'SUMMARY',
    CSS_MODIFIER: 'summary',
  },
  OUT_OF_TIME: {
    CONSTANT: 'OUT_OF_TIME',
    CSS_MODIFIER: 'out-of-time',
  },
};

export const BOARD_MODES = {
  LIVE: {
    CONSTANT: 'LIVE',
    DISPLAY_NAME: 'Live',
    CSS_MODIFIER: 'live',
  },
  TESTING: {
    CONSTANT: 'TESTING',
    DISPLAY_NAME: 'Testing',
    CSS_MODIFIER: 'testing',
  },
  DISABLED: {
    CONSTANT: 'DISABLED',
    DISPLAY_NAME: 'Disabled',
    CSS_MODIFIER: 'disabled',
  },
  LIVE_AND_TESTING: {
    CONSTANT: 'LIVE_AND_TESTING',
    DISPLAY_NAME: 'Live & Testing',
    CSS_MODIFIER: 'live-and-testing',
  },
};

export const BOARD_MODES_SELECT_DATA = [
  {
    value: BOARD_MODES.LIVE.CONSTANT,
    label: BOARD_MODES.LIVE.DISPLAY_NAME,
  },
  {
    value: BOARD_MODES.TESTING.CONSTANT,
    label: BOARD_MODES.TESTING.DISPLAY_NAME,
  },
  {
    value: BOARD_MODES.DISABLED.CONSTANT,
    label: BOARD_MODES.DISABLED.DISPLAY_NAME,
  },
];

export const BOARD_MODES_FILTER_SELECT_DATA = [
  {
    value: BOARD_MODES.LIVE.CONSTANT,
    label: BOARD_MODES.LIVE.DISPLAY_NAME,
  },
  {
    value: BOARD_MODES.TESTING.CONSTANT,
    label: BOARD_MODES.TESTING.DISPLAY_NAME,
  },
  {
    value: BOARD_MODES.DISABLED.CONSTANT,
    label: BOARD_MODES.DISABLED.DISPLAY_NAME,
  },
  {
    value: BOARD_MODES.LIVE_AND_TESTING.CONSTANT,
    label: BOARD_MODES.LIVE_AND_TESTING.DISPLAY_NAME,
  },
];

export const PROMOTED = {
  PROMOTED: {
    CONSTANT: 'PROMOTED',
    DISPLAY_NAME: 'Promoted',
    CSS_MODIFIER: 'promoted',
    SELECT_VALUE: true,
  },
  NOT_PROMOTED: {
    CONSTANT: 'NOT_PROMOTED',
    DISPLAY_NAME: 'Not Promoted',
    CSS_MODIFIER: 'not-promoted',
    SELECT_VALUE: false,
  },
};

export const STARRED = {
  STARRED: {
    CONSTANT: 'STARRED',
    DISPLAY_NAME: 'Starred',
    CSS_MODIFIER: 'starred',
    SELECT_VALUE: true,
  },
  NOT_STARRED: {
    CONSTANT: 'NOT_STARRED',
    DISPLAY_NAME: 'Not Starred',
    CSS_MODIFIER: 'not-starred',
    SELECT_VALUE: false,
  },
};

export const FILTER_BOARDS_BY = {
  NO_FILTER: {
    CONSTANT: 'NO_FILTER',
    DISPLAY_NAME: 'No Filter',
  },
  BY_MODE: {
    CONSTANT: 'BY_MODE',
    DISPLAY_NAME: 'By Mode',
  },
  BY_PROMOTED: {
    CONSTANT: 'BY_PROMOTED',
    DISPLAY_NAME: 'By Promoted',
  },
  BY_STARRED: {
    CONSTANT: 'BY_STARRED',
    DISPLAY_NAME: 'By Starred',
  },
  BY_CATEGORY: {
    CONSTANT: 'BY_CATEGORY',
    DISPLAY_NAME: 'By Category',
  },
  BY_SUBSTRING: {
    CONSTANT: 'BY_SUBSTRING',
    DISPLAY_NAME: 'By Substring',
  },
  BY_KEYWORD: {
    CONSTANT: 'BY_KEYWORD',
    DISPLAY_NAME: 'By Keyword',
  },
  BY_ID: {
    CONSTANT: 'BY_ID',
    DISPLAY_NAME: 'By ID',
  },
  BY_LAYOUT: {
    CONSTANT: 'BY_LAYOUT',
    DISPLAY_NAME: 'By Layout',
  },
};

export const ORDER_BY = {
  CATEGORY: {
    CONSTANT: 'CATEGORY',
    DISPLAY_NAME: 'Category',
    PROPERTY: 'category',
  },
  ID: {
    CONSTANT: 'ID',
    DISPLAY_NAME: 'ID',
    PROPERTY: 'boardId',
  },
  NAME: {
    CONSTANT: 'NAME',
    DISPLAY_NAME: 'Name',
    PROPERTY: 'name',
  },
  MODE: {
    CONSTANT: 'MODE',
    DISPLAY_NAME: 'Mode',
    PROPERTY: 'mode',
  },
  LAYOUT: {
    CONSTANT: 'LAYOUT',
    DISPLAY_NAME: 'Layout',
    PROPERTY: 'boardPortraitLayout',
  },
  CREATION_DATE: {
    CONSTANT: 'CREATION_DATE',
    DISPLAY_NAME: 'Creation date',
    PROPERTY: 'boardCreatedAtSeconds',
  },
};

export const ORDER_BY_SELECT_DATA = [
  {
    value: ORDER_BY.CATEGORY.CONSTANT,
    label: ORDER_BY.CATEGORY.DISPLAY_NAME,
  },
  {
    value: ORDER_BY.CREATION_DATE.CONSTANT,
    label: ORDER_BY.CREATION_DATE.DISPLAY_NAME,
  },
  {
    value: ORDER_BY.ID.CONSTANT,
    label: ORDER_BY.ID.DISPLAY_NAME,
  },
  {
    value: ORDER_BY.LAYOUT.CONSTANT,
    label: ORDER_BY.LAYOUT.DISPLAY_NAME,
  },
  {
    value: ORDER_BY.MODE.CONSTANT,
    label: ORDER_BY.MODE.DISPLAY_NAME,
  },
  {
    value: ORDER_BY.NAME.CONSTANT,
    label: ORDER_BY.NAME.DISPLAY_NAME,
  },
];

export const ORDER_BY_DIRECTION = {
  ASCENDING: {
    CONSTANT: 'ASC',
    DISPLAY_NAME: 'Ascending',
  },
  DESCENDING: {
    CONSTANT: 'DESC',
    DISPLAY_NAME: 'Descending',
  },
};

export const ORDER_BY_DIRECTION_SELECT_DATA = [
  {
    value: ORDER_BY_DIRECTION.ASCENDING.CONSTANT,
    label: ORDER_BY_DIRECTION.ASCENDING.DISPLAY_NAME,
  },
  {
    value: ORDER_BY_DIRECTION.DESCENDING.CONSTANT,
    label: ORDER_BY_DIRECTION.DESCENDING.DISPLAY_NAME,
  },
];

export const COLOR_SCHEMES = {
  DARK: {
    CONSTANT: 'DARK',
    DISPLAY_NAME: 'Dark',
    DEFAULT_AVATAR_SUFFIX: 'dark',
    LOGO_SUFFIX: 'dark',
  },
  LIGHT: {
    CONSTANT: 'LIGHT',
    DISPLAY_NAME: 'Light',
    DEFAULT_AVATAR_SUFFIX: 'light',
    LOGO_SUFFIX: 'light',
  },
};

export const COLOR_SCHEMES_SELECT_DATA = [
  {
    value: COLOR_SCHEMES.DARK.CONSTANT,
    label: COLOR_SCHEMES.DARK.DISPLAY_NAME,
  },
  {
    value: COLOR_SCHEMES.LIGHT.CONSTANT,
    label: COLOR_SCHEMES.LIGHT.DISPLAY_NAME,
  },
];

export const PROMOTED_SELECT_DATA = [
  {
    value: PROMOTED.PROMOTED.SELECT_VALUE,
    label: PROMOTED.PROMOTED.DISPLAY_NAME,
  },
  {
    value: PROMOTED.NOT_PROMOTED.SELECT_VALUE,
    label: PROMOTED.NOT_PROMOTED.DISPLAY_NAME,
  },
];

export const STARRED_SELECT_DATA = [
  {
    value: STARRED.STARRED.SELECT_VALUE,
    label: STARRED.STARRED.DISPLAY_NAME,
  },
  {
    value: STARRED.NOT_STARRED.SELECT_VALUE,
    label: STARRED.NOT_STARRED.DISPLAY_NAME,
  },
];

export const TILE_BACKGROUND_SIZES = {
  CONTAIN: {
    CONSTANT: 'CONTAIN',
    DISPLAY_NAME: 'Contain',
    CSS_VALUE: 'contain',
  },
  COVER: {
    CONSTANT: 'COVER',
    DISPLAY_NAME: 'Cover',
    CSS_VALUE: 'cover',
  },
  PERCENT_130: {
    CONSTANT: 'PERCENT_130',
    DISPLAY_NAME: '130%',
    CSS_VALUE: '130%',
  },
  PERCENT_150: {
    CONSTANT: 'PERCENT_150',
    DISPLAY_NAME: '150%',
    CSS_VALUE: '150%',
  },
  PERCENT_170: {
    CONSTANT: 'PERCENT_170',
    DISPLAY_NAME: '170%',
    CSS_VALUE: '170%',
  },
  PERCENT_250: {
    CONSTANT: 'PERCENT_250',
    DISPLAY_NAME: '250%',
    CSS_VALUE: '250%',
  },
};

export const TILE_BACKGROUND_SIZES_SELECT_DATA = [
  {
    value: TILE_BACKGROUND_SIZES.CONTAIN.CONSTANT,
    label: TILE_BACKGROUND_SIZES.CONTAIN.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_SIZES.COVER.CONSTANT,
    label: TILE_BACKGROUND_SIZES.COVER.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_SIZES.PERCENT_130.CONSTANT,
    label: TILE_BACKGROUND_SIZES.PERCENT_130.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_SIZES.PERCENT_150.CONSTANT,
    label: TILE_BACKGROUND_SIZES.PERCENT_150.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_SIZES.PERCENT_170.CONSTANT,
    label: TILE_BACKGROUND_SIZES.PERCENT_170.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_SIZES.PERCENT_250.CONSTANT,
    label: TILE_BACKGROUND_SIZES.PERCENT_250.DISPLAY_NAME,
  },
];

export const TILE_BACKGROUND_POSITIONS = {
  CENTER: {
    CONSTANT: 'CENTER',
    DISPLAY_NAME: 'Center',
    CSS_VALUE: 'center',
  },
  TOP: {
    CONSTANT: 'TOP',
    DISPLAY_NAME: 'Top',
    CSS_VALUE: 'top',
  },
  BOTTOM: {
    CONSTANT: 'BOTTOM',
    DISPLAY_NAME: 'Bottom',
    CSS_VALUE: 'bottom',
  },
  LEFT: {
    CONSTANT: 'LEFT',
    DISPLAY_NAME: 'Left',
    CSS_VALUE: 'left',
  },
  RIGHT: {
    CONSTANT: 'RIGHT',
    DISPLAY_NAME: 'Right',
    CSS_VALUE: 'right',
  },
};

export const TILE_BACKGROUND_POSITIONS_SELECT_DATA = [
  {
    value: TILE_BACKGROUND_POSITIONS.CENTER.CONSTANT,
    label: TILE_BACKGROUND_POSITIONS.CENTER.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_POSITIONS.TOP.CONSTANT,
    label: TILE_BACKGROUND_POSITIONS.TOP.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_POSITIONS.BOTTOM.CONSTANT,
    label: TILE_BACKGROUND_POSITIONS.BOTTOM.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_POSITIONS.LEFT.CONSTANT,
    label: TILE_BACKGROUND_POSITIONS.LEFT.DISPLAY_NAME,
  },
  {
    value: TILE_BACKGROUND_POSITIONS.RIGHT.CONSTANT,
    label: TILE_BACKGROUND_POSITIONS.RIGHT.DISPLAY_NAME,
  },
];

export const BOARD_PORTRAIT_LAYOUTS_SELECT_DATA = [
  {
    value: '1x6',
    label: '1x6 (6)',
  },
  {
    value: '1x7',
    label: '1x7 (7)',
  },
  {
    value: '1x8',
    label: '1x8 (8)',
  },
  {
    value: '2x4',
    label: '2x4 (8)',
  },
  {
    value: '1x9',
    label: '1x9 (9)',
  },
  {
    value: '3x3',
    label: '3x3 (9)',
  },
  {
    value: '1x10',
    label: '1x10 (10)',
  },
  {
    value: '2x5',
    label: '2x5 (10)',
  },
  {
    value: '1x12',
    label: '1x12 (12)',
  },
  {
    value: '3x4',
    label: '3x4 (12)',
  },
  {
    value: '4x3',
    label: '4x3 (12)',
  },
  {
    value: '2x6',
    label: '2x6 (12)',
  },
  {
    value: '2x7',
    label: '2x7 (14)',
  },
  {
    value: '3x5',
    label: '3x5 (15)',
  },
  {
    value: '5x3',
    label: '5x3 (15)',
  },
  {
    value: '2x8',
    label: '2x8 (16)',
  },
  {
    value: '4x4',
    label: '4x4 (16)',
  },
  {
    value: '2x9',
    label: '2x9 (18)',
  },
  {
    value: '3x6',
    label: '3x6 (18)',
  },
  {
    value: '6x3',
    label: '6x3 (18)',
  },
  {
    value: '2x10',
    label: '2x10 (20)',
  },
  {
    value: '4x5',
    label: '4x5 (20)',
  },
  {
    value: '5x4',
    label: '5x4 (20)',
  },
  {
    value: '4x6',
    label: '4x6 (24)',
  },
  {
    value: '6x4',
    label: '6x4 (24)',
  },
  {
    value: '5x5',
    label: '5x5 (25)',
  },
  {
    value: '5x6',
    label: '5x6 (30)',
  },
  {
    value: '6x5',
    label: '6x5 (30)',
  },
  {
    value: '6x6',
    label: '6x6 (36)',
  },
];

export const CATEGORIES = {
  SPORT: {
    CONSTANT: 'SPORT',
    DISPLAY_NAME: 'Sport',
    CSS_MODIFIER: 'sport',
    SLUG: 'sport',
    COLOR: 'yellow',
  },
  MOVIES_TV: {
    CONSTANT: 'MOVIES_TV',
    DISPLAY_NAME: 'Movies & TV',
    CSS_MODIFIER: 'movies-tv',
    SLUG: 'movies-tv',
    COLOR: 'orange',
  },
  MUSIC: {
    CONSTANT: 'MUSIC',
    DISPLAY_NAME: 'Music',
    CSS_MODIFIER: 'music',
    SLUG: 'music',
    COLOR: 'pink',
  },
  BRANDING_LOGOS: {
    CONSTANT: 'BRANDING_LOGOS',
    DISPLAY_NAME: 'Branding & Logos',
    CSS_MODIFIER: 'branding-logos',
    SLUG: 'branding-logos',
    COLOR: 'violet',
  },
  GEOGRAPHY_LANGUAGE: {
    CONSTANT: 'GEOGRAPHY_LANGUAGE',
    DISPLAY_NAME: 'Geography & Language',
    CSS_MODIFIER: 'geography-language',
    SLUG: 'geography-language',
    COLOR: 'blue',
  },
  SCIENCE_NATURE: {
    CONSTANT: 'SCIENCE_NATURE',
    DISPLAY_NAME: 'Science & Nature',
    CSS_MODIFIER: 'science-nature',
    SLUG: 'science-nature',
    COLOR: 'green',
  },
  MATHS_COMPUTING: {
    CONSTANT: 'MATHS_COMPUTING',
    DISPLAY_NAME: 'Maths & Computing',
    CSS_MODIFIER: 'maths-computing',
    SLUG: 'maths-computing',
    COLOR: 'teal',
  },
  UNCATEGORISED: {
    CONSTANT: 'UNCATEGORISED',
    DISPLAY_NAME: 'Uncategorised',
    CSS_MODIFIER: 'uncategorised',
    SLUG: 'uncategorised',
    COLOR: 'brown',
  },
};

export const AVATARS = {
  DEFAULT: 'DEFAULT',
  GRAVATAR: 'GRAVATAR',
  CUSTOM: 'CUSTOM',
};

export const AVATAR_SELECT_DATA = [
  {
    value: AVATARS.DEFAULT,
    label: 'Default',
  },
  {
    value: AVATARS.GRAVATAR,
    label: 'Gravatar',
  },
  {
    value: AVATARS.CUSTOM,
    label: 'Custom',
  },
];

export const ORIENTATIONS = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
  SQUARE: 'SQUARE',
};

export const NOTIFICATION_SETTINGS = {
  backdrop: 0.4,
  closeOnClick: true,
  pauseOnHover: false,
  showProgressBar: false,
  timeout: 1500,
};

export const FIREBASE_STORAGE_RESIZED_IMAGE_SUFFIXES = {
  SIZE_33: {
    HEIGHT: 33,
    SUFFIX: '33x33',
    WIDTH: 33,
  },
  SIZE_100: {
    HEIGHT: 100,
    SUFFIX: '100x100',
    WIDTH: 100,
  },
  SIZE_200: {
    HEIGHT: 200,
    SUFFIX: '200x200',
    WIDTH: 200,
  },
  SIZE_400: {
    HEIGHT: 400,
    SUFFIX: '400x400',
    WIDTH: 400,
  },
  SIZE_800: {
    HEIGHT: 800,
    SUFFIX: '800x800',
    WIDTH: 800,
  },
};

export const NEW_TILES_ORDER_BY = {
  CREATION: {
    CONSTANT: 'CREATION',
    DISPLAY_NAME: 'Creation',
    PROPERTY: 'timestamp',
  },
  ID: {
    CONSTANT: 'ID',
    DISPLAY_NAME: 'ID',
    PROPERTY: 'tileId',
  },
  PROMPT: {
    CONSTANT: 'PROMPT',
    DISPLAY_NAME: 'Prompt',
    PROPERTY: 'prompt',
  },
};

export const NEW_TILES_ORDER_BY_SELECT_DATA = [
  {
    value: NEW_TILES_ORDER_BY.CREATION.CONSTANT,
    label: NEW_TILES_ORDER_BY.CREATION.DISPLAY_NAME,
  },
  {
    value: NEW_TILES_ORDER_BY.ID.CONSTANT,
    label: NEW_TILES_ORDER_BY.ID.DISPLAY_NAME,
  },
  {
    value: NEW_TILES_ORDER_BY.PROMPT.CONSTANT,
    label: NEW_TILES_ORDER_BY.PROMPT.DISPLAY_NAME,
  },
];
